import {useContext, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {AppBar, Avatar, Box, IconButton, Toolbar} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import {UserCircle as UserCircleIcon} from '../icons/user-circle';
import {AccountPopover} from './account-popover';
import Typography from "@mui/material/Typography";
import BaseAPIs from "../apis/base.apis";
import {AppStateContext} from "../App";

// @ts-ignore
const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
    // @ts-ignore
  backgroundColor: theme.palette.background.paper,
    // @ts-ignore
  boxShadow: theme.shadows[3]
}));

export const DashboardNavbar = (props:any) => {
  const { onSidebarOpen, ...other } = props;
  const settingsRef = useRef(null);
  const [openAccountPopover, setOpenAccountPopover] = useState(false);
  const host=new BaseAPIs().getApiBaseURL();
  const { loggedInUser } = useContext(AppStateContext);
  const isSuperAdmin = !!(loggedInUser && loggedInUser.admin && loggedInUser.admin.is_super_admin);
  return (
    <>
      <DashboardNavbarRoot
        sx={{
          left: {
            lg: 280
          },
          width: {
            lg: 'calc(100% - 280px)'
          }
        }}
        {...other}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            left: 0,
            px: 2
          }}
        >
          <IconButton
            onClick={onSidebarOpen}
            sx={{
              display: {
                xs: 'inline-flex',
                lg: 'none'
              }
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
            {isSuperAdmin && host && host.includes("https://tpi.uniquo.in") && <Typography color={"white"} bgcolor={"primary.main"} p={1} borderRadius={2}>
                Production
            </Typography>}
            {isSuperAdmin && host && !host.includes("https://tpi.uniquo.in") && <Typography color={"white"} bgcolor={"primary.main"} p={1} borderRadius={2}>
                BETA
            </Typography>}
          <Avatar
            onClick={() => setOpenAccountPopover(true)}
            ref={settingsRef}
            sx={{
              cursor: 'pointer',
              height: 40,
              width: 40,
              ml: 1
            }}
            src="/static/images/avatars/avatar_1.png"
          >
            <UserCircleIcon fontSize="small" />
          </Avatar>
        </Toolbar>
      </DashboardNavbarRoot>
      <AccountPopover
        anchorEl={settingsRef.current}
        open={openAccountPopover}
        onClose={() => setOpenAccountPopover(false)}
      />
    </>
  );
};

DashboardNavbar.propTypes = {
  onSidebarOpen: PropTypes.func
};
